export const weekdays = [
  { enUS: "Sunday", ptBR: "Dom" },
  { enUS: "Monday", ptBR: "Seg" },
  { enUS: "Tuesday", ptBR: "Ter" },
  { enUS: "Wednesday", ptBR: "Qua" },
  { enUS: "Thursday", ptBR: "Qui" },
  { enUS: "Friday", ptBR: "Sex" },
  { enUS: "Saturday", ptBR: "Sáb" },
];
